import { api } from "./client.js";
import { DEMO_PLAYER } from "./mock.js";
const demo = import.meta.env.VITE_DEMO_MODE === "true";
const DEMO_LEADERBOARD = {
    entries: [
        { rank: 1, id: "p1", firstName: "AlphaStrike", username: "alphastrike", rankPoints: 4120, rating: 1340, isMe: false },
        { rank: 2, id: "p2", firstName: "NullVoid", username: "nullvoid", rankPoints: 3880, rating: 1280, isMe: false },
        { rank: 3, id: "p3", firstName: "Demo", username: "xhog_demo", rankPoints: 525, rating: 512, isMe: true },
        { rank: 4, id: "p4", firstName: "Bastion7", username: null, rankPoints: 490, rating: 498, isMe: false },
        { rank: 5, id: "p5", firstName: "PulseX", username: "pulsex", rankPoints: 310, rating: 470, isMe: false },
    ],
    myEntry: null,
};
export const playerApi = {
    me: () => demo ? Promise.resolve(DEMO_PLAYER) : api.get("/player/me"),
    onboarding: () => demo
        ? Promise.resolve({ units: 4, squad: "Squad Alpha" })
        : api.post("/player/onboarding"),
    leaderboard: () => demo
        ? Promise.resolve(DEMO_LEADERBOARD)
        : api.get("/player/leaderboard"),
    getSettings: () => api.get("/player/settings"),
    updateSettings: (data) => api.patch("/player/settings", data),
};
